<template >
  <div class="print-order" style="color: #000 !important;">
    <el-dialog
      :title="generateCustomizeString('orderInvoice')"
      :visible.sync="orderDialogVisible"
      width="90%"
    >
      <!-- 头部选项框 start -->
      <div style="margin: -10px 30px 50px 10px;">
        <el-radio-group v-model="invoiceSelect" size="medium">
          <el-radio-button :label="generateCustomizeString('inclGST')"></el-radio-button>
          <el-radio-button :label="generateCustomizeString('plusGST')"></el-radio-button>
          <el-radio-button :label="generateCustomizeString('zeroGST')"></el-radio-button>
        </el-radio-group>
        <el-checkbox
          v-model="goodsImg"
          style="margin-left: 20px;"
        >{{ generateCustomizeString('merchandiseThumbnail') }}</el-checkbox>
        <el-checkbox
          v-model="noteComments"
          style="margin-left: 5px;"
        >{{ generateCustomizeString('noteComments') }}</el-checkbox>
        <el-checkbox
          v-model="showProductAbbreviation"
          style="margin-left: 5px;"
        >{{ generateCustomizeString('productAbbreviation') }}</el-checkbox>
        <el-checkbox
          v-model="showBarcode"
          style="margin-left: 5px;"
        >{{ generateCustomizeString('barcode') }}</el-checkbox>
        <el-button
          type="primary"
          class="noprint"
          @click="printWithDevice"
          style="float: right; margin-right: 50px;"
        >{{ generateCustomizeString('print') }}</el-button>
      </div>
      <!-- 头部选项框 end -->

      <div
        id="printIdForGoods"
        style="margin-top: -30px; padding: 0 10px;"
        v-loading="printLoading"
      >
        <!--  包含GST start -->
        <div
          style="margin-bottom: 30px; font-size: 12px;"
        >
          <div class="A4" v-for="(order, index) in orderDetailData" :key="index">

            <!-- 公司信息 start -->
            <h1 style="display: inline-block; line-height: 16px;">{{ shopData.display_shop_name }}</h1>
            <span style="padding-left: 20px; display: inline-block;">GST Number: {{shopData.gst_no}}</span>
            <div style="margin-top: -10px; line-height: 8px; font-size: 12px;">
              <p>{{ generateCustomizeString('companyPhone') }}:{{ shopData.merchant_contact_phone }}</p>
              <p>{{ generateCustomizeString('companyEmail') }}:{{ shopData.merchant_contact_email }}</p>
              <p>{{ generateCustomizeString('companyAddress') }}:{{ shopData.merchant_address }}</p>
            </div>
            <div style="text-align: left;">
              <svg :id="'barcode' + index" />
            </div>
            <div style="line-height: 8px; font-size: 13px;">
              <p>{{ generateCustomizeString('tradeNo') }}: {{ order.out_trade_no }}</p>
              <p>{{ generateCustomizeString('orderTime') }}: {{ order.created_at | toLocalTime }}</p>
              <p>{{ generateCustomizeString('customer') }}: {{ order.customer_name }}</p>
              <p
                v-if="order.customer.wechat_auths.length && order.customer.wechat_auths[0].user_info"
              >{{ generateCustomizeString('wechatName') }}: {{order.customer.wechat_auths[0].user_info.nickname}}</p>
              <p
                v-else
              >{{ generateCustomizeString('wechatName') }}: {{ generateCustomizeString('unbound') }}</p>
            </div>
            <div
              style="margin-bottom: 10px; font-size: 14px; line-height: 10px; font-weight: bold;"
              v-if="order.is_pick_up === 1"
            >{{ generateCustomizeString('isPickUpOrder') }}</div>
            <div v-else>
              <p style="font-weight: 800; font-size: 12px;">
                <u>{{ generateCustomizeString('shippingAddress') }}</u>
              </p>
              <div style="padding-left: 10px; line-height: 8px; font-size: 12px;">
                <p>{{ generateCustomizeString('name') }}: {{ order.order_address.consignee_name }}</p>
                <p>{{ generateCustomizeString('phoneNumber') }}: {{ order.order_address.phone }}</p>
                <p>{{ generateCustomizeString('contactAddress') }}: {{ order.order_address.address_detail }}</p>
                <p>{{ generateCustomizeString('identityNumber') }}: {{ order.order_address.person_id }}</p>
              </div>
            </div>
            <!-- 公司信息 end -->

            <!-- 顾客商户留言 start -->
            <div
              v-if="noteComments === true"
              style="margin-bottom: 5px;  font-size: 16px;  font-weight: bold;  line-height: 20px;  width: 700px;"
            >
              <u>
                <b>{{ generateCustomizeString('customerNote') }}:</b>
              </u>
              {{ order.message }}
            </div>
            <div
              v-if="noteComments === true"
              style="margin-bottom: 5px;  font-size: 16px;  font-weight: bold;  line-height: 20px;  width: 700px;"
            >
              <u>
                <b>{{ generateCustomizeString('sellerComments') }}:</b>
              </u>
              {{ order.to_customer_message }}
            </div>
            <!-- 顾客商户留言 end -->

            <!-- 商品列表 start -->
            <el-col style="line-height: 14px; float: none;">
              <p style="font-weight: 800;">{{ generateCustomizeString('orderGoods') }}</p>
              <el-table
                :data="order.order_goods"
                tooltip-effect="dark"
                border
                align="center"
                header-align="center"
                style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
                v-if="goodsImg === false"
                key="noImg"
              >
                <el-table-column type="index" width="30" key="index"></el-table-column>
                <el-table-column
                  prop="product_full_name"
                  key="product_full_name"
                  header-align="center"
                  :label="generateCustomizeString('productTitle')"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.product_full_name }}</div>
                    <div
                      v-if="scope.row.product_subtitle"
                      :key="scope.row.product_subtitle"
                      style="font-size: 12px;"
                    >{{scope.row.product_subtitle}}</div>
                    <div
                      style="font-size: 12px;"
                    >{{ generateCustomizeString('shippingWarehouse') }}: {{ scope.row.warehouse_name }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="showProductAbbreviation"
                  prop="product_abbreviation"
                  key="product_abbreviation"
                  header-align="center"
                  :label="generateCustomizeString('productAbbreviation')"
                ></el-table-column>
                <el-table-column
                  v-if="showBarcode"
                  prop="bar_code"
                  key="bar_code"
                  header-align="center"
                  :label="generateCustomizeString('barcode')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="unitPrice"
                  key="unitPrice"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('unitPrice')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{ parseFloat(scope.row.order_price / 100).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="quantity"
                  key="quantity"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('quantity')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="total"
                  key="total"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('subtotal')"
                  width="109"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{ parseFloat(scope.row.order_price * scope.row.quantity / 100).toFixed(2) }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                :data="order.order_goods"
                tooltip-effect="dark"
                border
                align="center"
                header-align="center"
                style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
                v-else
                key="img"
              >
                <el-table-column type="index" width="30" key="index"></el-table-column>
                <el-table-column
                  prop="product_full_name"
                  key="product_full_name"
                  header-align="center"
                  :label="generateCustomizeString('productTitle')"
                >
                  <template slot-scope="scope">
                    <div>{{scope.row.product_full_name}}</div>
                    <div
                      v-if="scope.row.product_subtitle"
                      :key="scope.row.product_subtitle"
                      style="font-size: 12px;"
                    >{{scope.row.product_subtitle}}</div>
                    <div
                      style="font-size: 12px;"
                    >{{ generateCustomizeString('shippingWarehouse') }}: {{ scope.row.warehouse_name }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="showProductAbbreviation"
                  prop="product_abbreviation"
                  key="product_abbreviation"
                  header-align="center"
                  :label="generateCustomizeString('productAbbreviation')"
                ></el-table-column>
                <el-table-column
                  v-if="showBarcode"
                  prop="bar_code"
                  key="bar_code"
                  header-align="center"
                  :label="generateCustomizeString('barcode')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="goodsImg"
                  key="goodsImg"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('merchandiseThumbnail')"
                  width="70"
                  style="text-align: center;"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.first_image_url + '?imageView2/1/w/200/h/200/q/75|imageslim'"
                      style="width:auto;height:40px;"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="unitPrice"
                  key="unitPrice"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('unitPrice')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{ parseFloat(scope.row.order_price / 100).toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="quantity"
                  key="quantity"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('quantity')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="total"
                  key="total"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('subtotal')"
                  width="109"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{ parseFloat(scope.row.order_price * scope.row.quantity / 100).toFixed(2) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <!-- 商品列表 end -->

            <!-- 金额详情 - 已含GST start -->
            <div v-if="invoiceSelect === generateCustomizeString('inclGST')">
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('totalQty') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >{{order.totalQuantity}}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('goods') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{parseFloat(order.goods_fee / 100).toFixed(2)}}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span style="width: 100px; text-align: right; display: inline-block;">GST Incl:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{parseFloat(order.goods_fee / 100 * 3 / 23).toFixed(2)}}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_activity_reduction && order.order_fee_detail.total_activity_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('promotion') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{parseFloat(order.order_fee_detail.total_activity_reduction / 100).toFixed(2)}}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align:right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_coupon_reduction && order.order_fee_detail.total_coupon_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('coupon') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{parseFloat(order.order_fee_detail.total_coupon_reduction / 100).toFixed(2)}}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 150px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('goodsSubtotalInclGST') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.cost_goods_fee_after_discounted / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('sellShippingFee') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.express_fee / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_express_fee_reduction && order.order_fee_detail.total_express_fee_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('shippingFeePromotion') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{parseFloat(order.order_fee_detail.total_express_fee_reduction / 100).toFixed(2)}}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('total') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.fee / 100).toFixed(2) }}</span>
                </span>
              </div>

              <!-- 支付方式 start -->
              <div style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;">
                <span style="padding-right: 20px;">
                  <span style="width: 100px; text-align: right; display: inline-block;">
                    {{ generateCustomizeString('payType') }}:&nbsp;</span>
                    <span v-for="type in order.transactions" :key="type.id" >
                      <span v-if="[1, 2].includes(type.status)">
                        {{ type.pay_type_string }}:
                        ${{ parseFloat(type.fee / 100).toFixed(2) }}
                      </span>
                    </span>
                </span>
              </div>
              <!-- 支付方式 end -->
            </div>
            <!-- 金额详情 已含GST end -->

            <!-- 金额详情 plus GST start -->
            <div v-else-if="invoiceSelect === generateCustomizeString('plusGST')">
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('numberOfProducts') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >{{ order.totalQuantity }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('goods') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.goods_fee / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span style="width: 100px; text-align: right; display: inline-block;">15% GST:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{parseFloat(order.goods_fee / 100 * 0.15).toFixed(2)}}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_activity_reduction && order.order_fee_detail.total_activity_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('promotion') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{ parseFloat(order.order_fee_detail.total_activity_reduction / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_coupon_reduction && order.order_fee_detail.total_coupon_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('coupon') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{ parseFloat(order.order_fee_detail.total_coupon_reduction / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 150px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('goodsSubtotalInclGST') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.goods_fee / 100 * 1.15 - (order.order_fee_detail.total_activity_reduction / 100) - (order.order_fee_detail.total_coupon_reduction / 100)).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('sellShippingFee') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.express_fee / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_express_fee_reduction && order.order_fee_detail.total_express_fee_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('shippingFeePromotion') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{ parseFloat(order.order_fee_detail.total_express_fee_reduction / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('total') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat((order.goods_fee / 100 * 1.15) - (order.order_fee_detail.total_activity_reduction / 100) - (order.order_fee_detail.total_coupon_reduction / 100) + (order.order_fee_detail.total_express_fee_after_discounted / 100)).toFixed(2) }}</span>
                </span>
              </div>

              <!-- 支付方式 start -->
              <div style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;">
                <span style="padding-right: 20px;">
                  <span style="width: 100px; text-align: right; display: inline-block;">
                    {{ generateCustomizeString('payType') }}:&nbsp;</span>
                    <span v-for="type in order.transactions" :key="type.id" >
                      <span v-if="[1, 2].includes(type.status)">
                        {{ type.pay_type_string }}:
                        ${{ parseFloat(type.fee / 100).toFixed(2) }}
                      </span>
                    </span>
                </span>
              </div>
              <!-- 支付方式 end -->
            </div>
            <!-- 金额详情 plus GST end -->

            <!-- 金额详情 0 GST star -->
            <div v-else-if="invoiceSelect === generateCustomizeString('zeroGST')">
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('numberOfProducts') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >{{ order.totalQuantity }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('goods') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.goods_fee / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span style="width: 100px; text-align: right; display: inline-block;">GST:&nbsp;</span>
                  <span style="width: 80px; text-align: left; display: inline-block;">NZ $0.00</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail.total_activity_reduction && order.order_fee_detail.total_activity_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('promotionActivity') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{ parseFloat(order.order_fee_detail.total_activity_reduction / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_coupon_reduction && order.order_fee_detail.total_coupon_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('coupon') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{ parseFloat(order.order_fee_detail.total_coupon_reduction / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 150px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('goodsSubtotalZeroGST') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.cost_goods_fee_after_discounted / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('sellShippingFee') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.express_fee / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
                v-if="order.order_fee_detail && order.order_fee_detail.total_express_fee_reduction && order.order_fee_detail.total_express_fee_reduction > 0"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('shippingFeePromotion') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >-NZ ${{ parseFloat(order.order_fee_detail.total_express_fee_reduction / 100).toFixed(2) }}</span>
                </span>
              </div>
              <div
                style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              >
                <span style="padding-right: 20px;">
                  <span
                    style="width: 100px; text-align: right; display: inline-block;"
                  >{{ generateCustomizeString('total') }}:&nbsp;</span>
                  <span
                    style="width: 80px; text-align: left; display: inline-block;"
                  >NZ ${{ parseFloat(order.fee / 100).toFixed(2) }}</span>
                </span>
              </div>

              <!-- 支付方式 start -->
              <div style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;">
                <span style="padding-right: 20px;">
                  <span style="width: 100px; text-align: right; display: inline-block;">
                    {{ generateCustomizeString('payType') }}:&nbsp;</span>
                    <span v-for="type in order.transactions" :key="type.id" >
                      <span v-if="[1, 2].includes(type.status)">
                        {{ type.pay_type_string }}:
                        ${{ parseFloat(type.fee / 100).toFixed(2) }}
                      </span>
                    </span>
                </span>
              </div>
              <!-- 支付方式 end -->
            </div>
            <!-- 金额详情 0 GST end -->

            <!-- 页脚信息 start -->
            <div style="line-height: 8px; margin-bottom: 100px; page-break-before: auto;">
              <p style="font-weight: bold;">Important:</p>
              <p
                style="padding-left: 20px;"
              >1. This is an electronic generated invoice so does not require any signature.</p>
              <p
                style="padding-left: 20px;"
              >2. Please read all terms and polices for returns, replacement and other issues.</p>
            </div>
            <!-- 页脚信息 end -->
          </div>
        </div>
        <!--  包含GST end -->

         <!-- 加GST start -->
        <!-- <div
          v-else-if="this.invoiceSelect === generateCustomizeString('plusGST')"
          style="margin-bottom: 30px; font-size: 12px;"
        >
          <div class="A4" v-for="(order, index) in orderDetailData" :key="index">
            <h1 style="display: inline-block; line-height: 16px;">{{shopData.display_shop_name}}</h1>
            <span style="padding-left: 20px; display: inline-block;">GST Number: {{shopData.gst_no}}</span>
            <div style="margin-top: -10px; line-height: 8px; font-size: 12px;">
              <p>{{ generateCustomizeString('companyPhone') }}:{{shopData.merchant_contact_phone}}</p>
              <p>{{ generateCustomizeString('companyEmail') }}:{{shopData.merchant_contact_email}}</p>
              <p>{{ generateCustomizeString('companyAddress') }}:{{shopData.merchant_address}}</p>
            </div>
            <div style="text-align: left;">
              <svg :id="'barcode' + index" />
            </div>
            <div style="line-height: 8px; font-size: 13px;">
              <p>{{ generateCustomizeString('tradeNo') }}: {{order.out_trade_no}}</p>
              <p>{{ generateCustomizeString('orderTime') }}: {{order.created_at | toLocalTime}}</p>
              <p>{{ generateCustomizeString('customer') }}: {{order.customer_name}}</p>
              <p
                v-if="order.customer.wechat_auths.length && order.customer.wechat_auths[0].user_info"
              >{{ generateCustomizeString('wechatName') }}: {{order.customer.wechat_auths[0].user_info.nickname}}</p>
              <p
                v-else
              >{{ generateCustomizeString('wechatName') }}: {{ generateCustomizeString('unbound') }}</p>
            </div>
            <div
              style="margin-bottom: 10px; font-size: 14px; line-height: 10px; font-weight: bold;"
              v-if="order.is_pick_up === 1"
            >{{ generateCustomizeString('isPickUpOrder') }}</div>
            <div v-else>
              <p style="font-weight: 800; font-size: 12px;">
                <u>{{ generateCustomizeString('shippingAddress') }}</u>
              </p>
              <div style="padding-left: 10px; line-height: 8px; font-size: 12px;">
                <p>{{ generateCustomizeString('name') }}: {{order.order_address.consignee_name}}</p>
                <p>{{ generateCustomizeString('phoneNumber') }}: {{order.order_address.phone}}</p>
                <p>{{ generateCustomizeString('contactAddress') }}: {{order.order_address.address_detail}}</p>
                <p>{{ generateCustomizeString('identityNumber') }}: {{order.order_address.person_id}}</p>
              </div>
            </div>
            <div style="margin-bottom: 5px; font-size: 16px; font-weight: bold; line-height: 20px;">
              <u>
                <b>{{ generateCustomizeString('customerNote') }}:</b>
              </u>
              {{order.message}}
            </div>
            <div style="margin-bottom: 5px; font-size: 16px; font-weight: bold; line-height: 20px;">
              <u>
                <b>{{ generateCustomizeString('sellerComments') }}:</b>
              </u>
              {{order.to_customer_message}}
            </div>
            <el-col style="line-height: 14px; float: none;">
              <p style="font-weight: 800;">{{ generateCustomizeString('orderGoods') }}</p>
              <el-table
                :data="order.order_goods"
                tooltip-effect="dark"
                border
                align="center"
                header-align="center"
                style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
                v-if="goodsImg === false"
              >
                <el-table-column type="index" width="30" key="index"></el-table-column>
                <el-table-column
                  prop="product_full_name"
                  key="product_full_name"
                  header-align="center"
                  :label="generateCustomizeString('productTitle')"
                >
                  <template slot-scope="scope">
                    <div>{{scope.row.product_full_name}}</div>
                    <div
                      v-if="scope.row.product_subtitle"
                      :key="scope.row.product_subtitle"
                      style="font-size: 12px;"
                    >{{scope.row.product_subtitle}}</div>
                    <div
                      style="font-size: 12px;"
                    >{{ generateCustomizeString('shippingWarehouse') }}: {{scope.row.warehouse_name}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="showProductAbbreviation"
                  prop="product_abbreviation"
                  key="product_abbreviation"
                  header-align="center"
                  :label="generateCustomizeString('productAbbreviation')"
                ></el-table-column>
                <el-table-column
                  v-if="showBarcode"
                  prop="bar_code"
                  key="bar_code"
                  header-align="center"
                  :label="generateCustomizeString('barcode')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="unitPrice"
                  key="unitPrice"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('unitPrice')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="quantity"
                  key="quantity"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('quantity')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="total"
                  key="total"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('subtotal')"
                  width="109"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price * scope.row.quantity / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                :data="order.order_goods"
                tooltip-effect="dark"
                border
                align="center"
                header-align="center"
                style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
                v-else
              >
                <el-table-column type="index" width="30" key="index"></el-table-column>
                <el-table-column
                  prop="product_full_name"
                  key="product_full_name"
                  header-align="center"
                  :label="generateCustomizeString('productTitle')"
                >
                  <template slot-scope="scope">
                    <div>{{scope.row.product_full_name}}</div>
                    <div
                      v-if="scope.row.product_subtitle"
                      :key="scope.row.product_subtitle"
                      style="font-size: 12px;"
                    >{{scope.row.product_subtitle}}</div>
                    <div
                      style="font-size: 12px;"
                    >{{ generateCustomizeString('shippingWarehouse') }}: {{scope.row.warehouse_name}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="showProductAbbreviation"
                  prop="product_abbreviation"
                  key="product_abbreviation"
                  header-align="center"
                  :label="generateCustomizeString('productAbbreviation')"
                ></el-table-column>
                <el-table-column
                  v-if="showBarcode"
                  prop="bar_code"
                  key="bar_code"
                  header-align="center"
                  :label="generateCustomizeString('barcode')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="goodsImg"
                  key="goodsImg"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('merchandiseThumbnail')"
                  width="70"
                  style="text-align: center;"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.first_image_url + '?imageView2/1/w/200/h/200/q/75|imageslim'"
                      style="width:auto;height:40px;"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="unitPrice"
                  key="unitPrice"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('unitPrice')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="quantity"
                  key="quantity"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('quantity')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="total"
                  key="total"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('subtotal')"
                  width="109"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price * scope.row.quantity / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('numberOfProducts') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >{{order.totalQuantity}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('goods') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.goods_fee / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span style="width: 100px; text-align: right; display: inline-block;">15% GST：</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.goods_fee / 100 * 0.15).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              v-if="order.order_fee_detail && order.order_fee_detail.total_activity_reduction && order.order_fee_detail.total_activity_reduction > 0"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('promotion') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >-NZ ${{parseFloat(order.order_fee_detail.total_activity_reduction / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              v-if="order.order_fee_detail && order.order_fee_detail.total_coupon_reduction && order.order_fee_detail.total_coupon_reduction > 0"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('coupon') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >-NZ ${{parseFloat(order.order_fee_detail.total_coupon_reduction / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 150px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('goodsSubtotalInclGST') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.goods_fee / 100 * 1.15 - (order.order_fee_detail.total_activity_reduction / 100) - (order.order_fee_detail.total_coupon_reduction / 100)).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('sellShippingFee') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.express_fee / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              v-if="order.order_fee_detail && order.order_fee_detail.total_express_fee_reduction && order.order_fee_detail.total_express_fee_reduction > 0"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('shippingFeePromotion') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >-NZ ${{parseFloat(order.order_fee_detail.total_express_fee_reduction / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('total') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat((order.goods_fee / 100 * 1.15) - (order.order_fee_detail.total_activity_reduction / 100) - (order.order_fee_detail.total_coupon_reduction / 100) + (order.order_fee_detail.total_express_fee_after_discounted / 100)).toFixed(2)}}</span>
              </span>
            </div>
            <div style="line-height: 8px; margin-bottom: 100px;">
              <p style="font-weight: bold;">Important:</p>
              <p
                style="padding-left: 20px;"
              >1. This is an electronic generated invoice so does not require any signature.</p>
              <p
                style="padding-left: 20px;"
              >2. Please read all terms and polices for returns, replacement and other issues.</p>
            </div>
          </div>
        </div>
         加GST end -->

        <!-- 发国内0 GST start -->
        <!-- <div
          v-else-if="this.invoiceSelect === generateCustomizeString('zeroGST')"
          style="margin-bottom: 30px; font-size: 12px;"
        >
          <div class="A4" v-for="(order, index) in orderDetailData" :key="index">
            <h1 style="display: inline-block; line-height: 16px;">{{shopData.display_shop_name}}</h1>
            <span style="padding-left: 20px; display: inline-block;">GST Number: {{shopData.gst_no}}</span>
            <div style="margin-top: -10px; line-height: 8px; font-size: 12px;">
              <p>{{ generateCustomizeString('companyPhone') }}: {{shopData.merchant_contact_phone}}</p>
              <p>{{ generateCustomizeString('companyEmail') }}: {{shopData.merchant_contact_email}}</p>
              <p>{{ generateCustomizeString('companyAddress') }}: {{shopData.merchant_address}}</p>
            </div>
            <div style="text-align: left;">
              <svg :id="'barcode' + index" />
            </div>
            <div style="line-height: 8px; font-size: 13px;">
              <p>{{ generateCustomizeString('tradeNo') }}: {{order.out_trade_no}}</p>
              <p>{{ generateCustomizeString('orderTime') }}: {{order.created_at | toLocalTime}}</p>
              <p>{{ generateCustomizeString('customer') }}: {{order.customer_name}}</p>
              <p
                v-if="order.customer.wechat_auths.length && order.customer.wechat_auths[0].user_info"
              >{{ generateCustomizeString('wechatName') }}: {{order.customer.wechat_auths[0].user_info.nickname}}</p>
              <p
                v-else
              >{{ generateCustomizeString('wechatName') }}: {{ generateCustomizeString('unbound') }}</p>
            </div>
            <div
              style="margin-bottom: 10px; font-size: 14px; line-height: 10px; font-weight: bold;"
              v-if="order.is_pick_up === 1"
            >{{ generateCustomizeString('isPickUpOrder') }}</div>
            <div v-else>
              <p style="font-weight: 800; font-size: 12px;">
                <u>{{ generateCustomizeString('shippingAddress') }}</u>
              </p>
              <div style="padding-left: 10px; line-height: 8px; font-size: 12px;">
                <p>{{ generateCustomizeString('name') }}: {{order.order_address.consignee_name}}</p>
                <p>{{ generateCustomizeString('phoneNumber') }}: {{order.order_address.phone}}</p>
                <p>{{ generateCustomizeString('contactAddress') }}:{{order.order_address.address_detail}}</p>
                <p>{{ generateCustomizeString('identityNumber') }}: {{order.order_address.person_id}}</p>
              </div>
            </div>
            <div style="margin-bottom: 5px; font-size: 16px; font-weight: bold; line-height: 20px;">
              <u>
                <b>{{ generateCustomizeString('customerNote') }}:</b>
              </u>
              {{order.message}}
            </div>
            <div style="margin-bottom: 5px; font-size: 16px; font-weight: bold; line-height: 20px;">
              <u>
                <b>{{ generateCustomizeString('sellerComments') }}:</b>
              </u>
              {{order.to_customer_message}}
            </div>
            <el-col style="line-height: 14px; float: none;">
              <p style="font-weight: 800;">{{ generateCustomizeString('orderGoods') }}:</p>
              <el-table
                :data="order.order_goods"
                tooltip-effect="dark"
                border
                align="center"
                header-align="center"
                style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
                v-if="goodsImg === false"
              >
                <el-table-column type="index" width="30" key="index"></el-table-column>
                <el-table-column
                  prop="product_full_name"
                  key="product_full_name"
                  header-align="center"
                  :label="generateCustomizeString('productTitle')"
                >
                  <template slot-scope="scope">
                    <div>{{scope.row.product_full_name}}</div>
                    <div
                      v-if="scope.row.product_subtitle"
                      :key="scope.row.product_subtitle"
                      style="font-size: 12px;"
                    >{{scope.row.product_subtitle}}</div>
                    <div
                      style="font-size: 12px;"
                    >{{ generateCustomizeString('shippingWarehouse') }}: {{scope.row.warehouse_name}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="showProductAbbreviation"
                  prop="product_abbreviation"
                  key="product_abbreviation"
                  header-align="center"
                  :label="generateCustomizeString('productAbbreviation')"
                ></el-table-column>
                <el-table-column
                  v-if="showBarcode"
                  prop="bar_code"
                  key="bar_code"
                  header-align="center"
                  :label="generateCustomizeString('barcode')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="unitPrice"
                  key="unitPrice"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('unitPrice')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="quantity"
                  key="quantity"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('quantity')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="total"
                  key="total"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('subtotal')"
                  width="109"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price * scope.row.quantity / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                :data="order.order_goods"
                tooltip-effect="dark"
                border
                align="center"
                header-align="center"
                style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
                v-else
              >
                <el-table-column type="index" width="30" key="index"></el-table-column>
                <el-table-column
                  prop="product_full_name"
                  key="product_full_name"
                  header-align="center"
                  :label="generateCustomizeString('productTitle')"
                >
                  <template slot-scope="scope">
                    <div>{{scope.row.product_full_name}}</div>
                    <div
                      v-if="scope.row.product_subtitle"
                      :key="scope.row.product_subtitle"
                      style="font-size: 12px;"
                    >{{scope.row.product_subtitle}}</div>
                    <div
                      style="font-size: 12px;"
                    >{{ generateCustomizeString('shippingWarehouse') }}: {{scope.row.warehouse_name}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="showProductAbbreviation"
                  prop="product_abbreviation"
                  key="product_abbreviation"
                  header-align="center"
                  :label="generateCustomizeString('productAbbreviation')"
                ></el-table-column>
                <el-table-column
                  v-if="showBarcode"
                  prop="bar_code"
                  key="bar_code"
                  header-align="center"
                  :label="generateCustomizeString('barcode')"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="goodsImg"
                  key="goodsImg"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('merchandiseThumbnail')"
                  width="70"
                  style="text-align: center;"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.first_image_url + '?imageView2/1/w/200/h/200/q/75|imageslim'"
                      style="width:auto;height:40px;"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="unitPrice"
                  key="unitPrice"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('unitPrice')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="quantity"
                  key="quantity"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('quantity')"
                  width="60"
                ></el-table-column>
                <el-table-column
                  prop="total"
                  key="total"
                  align="center"
                  header-align="center"
                  :label="generateCustomizeString('subtotal')"
                  width="109"
                >
                  <template slot-scope="scope">
                    <span>NZ ${{parseFloat(scope.row.order_price * scope.row.quantity / 100).toFixed(2)}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('numberOfProducts') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >{{order.totalQuantity}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('goods') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.goods_fee / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span style="width: 100px; text-align: right; display: inline-block;">GST：</span>
                <span style="width: 80px; text-align: left; display: inline-block;">NZ $0.00</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              v-if="order.order_fee_detail.total_activity_reduction && order.order_fee_detail.total_activity_reduction > 0"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('promotionActivity') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >-NZ ${{parseFloat(order.order_fee_detail.total_activity_reduction / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              v-if="order.order_fee_detail && order.order_fee_detail.total_coupon_reduction && order.order_fee_detail.total_coupon_reduction > 0"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('coupon') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >-NZ ${{parseFloat(order.order_fee_detail.total_coupon_reduction / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 150px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('goodsSubtotalZeroGST') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.cost_goods_fee_after_discounted / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('sellShippingFee') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.express_fee / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
              v-if="order.order_fee_detail && order.order_fee_detail.total_express_fee_reduction && order.order_fee_detail.total_express_fee_reduction > 0"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('shippingFeePromotion') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >-NZ ${{parseFloat(order.order_fee_detail.total_express_fee_reduction / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div
              style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            >
              <span style="padding-right: 20px;">
                <span
                  style="width: 100px; text-align: right; display: inline-block;"
                >{{ generateCustomizeString('total') }}:</span>
                <span
                  style="width: 80px; text-align: left; display: inline-block;"
                >NZ ${{parseFloat(order.fee / 100).toFixed(2)}}</span>
              </span>
            </div>
            <div style="line-height: 8px; margin-bottom: 100px;">
              <p style="font-weight: bold;">Important:</p>
              <p
                style="padding-left: 20px;"
              >1. This is an electronic generated invoice so does not require any signature.</p>
              <p
                style="padding-left: 20px;"
              >2. Please read all terms and polices for returns, replacement and other issues.</p>
            </div>
          </div>
        </div> -->
        <!-- 发国内0 GST end -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { generateCustomizeString } from '@/utils/i18n'
import JsBarcode from 'jsbarcode'
import { mapGetters } from 'vuex'

export default {
  name: 'PrintInvoice',
  data() {
    return {
      orderDialogVisible: false,
      orderDetailData: [],
      orderProductData: [],
      orderAddressData: [],
      shopData: [],
      orderCustomer: [],
      ids: '',
      printLoading: false,
      totalQuantity: 0,
      goodsImg: false,
      noteComments: false,
      showProductAbbreviation: false,
      invoiceSelect: this.generateCustomizeString('inclGST'),
      showBarcode: false
    }
  },
  computed: {
    ...mapGetters([
      'shop_id'
    ])
  },
  created() {
    if (this.shop_id === 1061) {
      this.invoiceSelect = this.generateCustomizeString('zeroGST')
      this.showBarcode = true
    }
  },
  methods: {
    generateCustomizeString,
    fetchOrder(ids) {
      return new Promise((resolve, reject) => {
        request({
          url: '/order/picking/' + ids,
          method: 'get'
        })
          .then(response => {
            console.log(response.data)
            this.orderDetailData = response.data
            console.log(this.orderDetailData)
            for (var i = 0; i < this.orderDetailData.length; i++) {
              this.totalQuantity = 0
              for (
                let j = 0;
                j < this.orderDetailData[i].order_goods.length;
                j++
              ) {
                this.totalQuantity += this.orderDetailData[i].order_goods[
                  j
                ].quantity
              }
              this.orderDetailData[i]['totalQuantity'] = this.totalQuantity

              // 如果有category_id的话, 按照category_id来排序
              if (this.orderDetailData[i].order_goods[0].category_id !== null) {
                this.orderDetailData[i].order_goods.sort(function(a, b) {
                  return a.category_id - b.category_id
                })
              }
              console.log(this.orderDetailData)
            }
            resolve()
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            this.getBarcode()
          })
      })
    },
    getBarcode() {
      for (var i = 0; i < this.orderDetailData.length; i++) {
        JsBarcode('#barcode' + i, this.orderDetailData[i].out_trade_no, {
          width: 2,
          height: 30,
          fontSize: 10,
          displayValue: false
        })
      }
    },
    fetchShopDetail() {
      return new Promise((resolve, reject) => {
        request({
          url: 'basic',
          method: 'get'
        })
          .then(response => {
            this.shopData = response.data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    handlePrintClick(ids) {
      this.printLoading = true

      Promise.all([this.fetchShopDetail(), (this.orderDialogVisible = true)])
        .then(result => {
          this.fetchOrder(ids)
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.printLoading = false
        })
    },
    printWithDevice() {
      this.orderDialogVisible = false
      var mywindow = window.open('', 'PRINT')
      mywindow.document.write(
        '<html><head><link rel="stylesheet" type="text/css" href="https://unpkg.com/element-ui/lib/theme-chalk/index.css" media="print"><title>订单 Invoice</title><script type="text/javascript" src="https://unpkg.com/element-ui/lib/index.js"></sc' +
          'ript><style type="text/css"> .el-table td, .el-table th { padding: 2px 0 !important; line-height: 12px; font-size:12px; } .A4 { page-break-before: auto; page-break-after: always; }</style><style type="text/css" media="print"> .noprint { display:none;} </style></head>'
      )
      mywindow.document.write('<body >')
      mywindow.document.write(
        document.getElementById('printIdForGoods').innerHTML
      )
      mywindow.document.write(
        '</body><script>setInterval(window.print(), 1000);</scr' + 'ipt>'
      )
      mywindow.document.write('</html>')
      mywindow.document.close()
      mywindow.focus()
    }
  }
}
</script>

<style type="text/css">
.print-order .el-dialog__wrapper {
  z-index: 1000000 !important;
}
</style>
